import { Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SharedService } from '../../../../shared/services/shared.service';
import { environment } from '../../../../../environments/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from '../../../../shared/services/utils.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
	selector: 'app-landing-info',
	standalone: true,
	imports: [CommonModule, TranslateModule, MatDividerModule, MatButtonModule],
	templateUrl: './landing-info.component.html',
	styleUrl: './landing-info.component.scss',
})
export class LandingInfoComponent {
	resellerSettingsContext: any;
  mobileView = false;
	data: any = [];
  pageType!: string;
	constructor(private responsive: BreakpointObserver, private sharedService: SharedService, private route: ActivatedRoute, public utils: UtilsService) {
		this.sharedService.resellerSettingsContext.pipe(takeUntilDestroyed()).subscribe({
			next: response => {
				this.resellerSettingsContext = response;
				this.resellerSettingsContext.reseller = environment.reseller;
			},
		});

    this.route.params.pipe(takeUntilDestroyed()).subscribe(params => {
      this.pageType = params['type']
      setTimeout(() => {
        this.data = this.resellerSettingsContext[this.pageType].data;
      }, 250);
    });

		this.responsive
			.observe([Breakpoints.XSmall, Breakpoints.Small])
			.pipe(takeUntilDestroyed())
			.subscribe(result => {
				this.mobileView = false;

				if (result.matches) {
					this.mobileView = true;
				}
			});
	}
}
